import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Button } from '@ncoder/ui';
import { ValidationMetric } from '../../atoms/training/ValidationMetric';
import { Play } from 'lucide-react';

interface ValidationResultsProps {
  accuracy: string;
  precision: string;
  recall: string;
  onRunValidation?: () => void;
}

export const ValidationResults: React.FC<ValidationResultsProps> = ({
  accuracy,
  precision,
  recall,
  onRunValidation,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Validation Results</CardTitle>
        <CardDescription>Test your agent's performance</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-3 gap-4">
          <ValidationMetric value={accuracy} label="Accuracy" color="green" />
          <ValidationMetric value={precision} label="Precision" color="blue" />
          <ValidationMetric value={recall} label="Recall" color="purple" />
        </div>
        <Button className="w-full" onClick={onRunValidation}>
          <Play className="h-4 w-4 mr-2" />
          Run Validation Test
        </Button>
      </CardContent>
    </Card>
  );
};
